/* eslint-disable @typescript-eslint/no-unused-vars */
import {  useEffect, useState } from 'react';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Paper, Snackbar, SnackbarCloseReason, TextField } from '@mui/material';
import * as yup from 'yup';
import { FeriasService } from '../../../shared/services/api/rh/ferias/FeriasService';
import { IVFormErrors, useVForm, VFieldMoney, VForm, VTextFieldData } from '../../../shared/forms';

interface IFormData {
  datainicial: Date;
  datafinal: Date;
  valorinss: number;
}

export interface ConfirmationDialogRawProps {
  id: string;
  dados?: IFormData;
  value: string;
  open: boolean;
  onClose: (value?: string) => void;
}

const FeriasSchema = yup.object().shape({
  datainicial: yup.date().required(),
  datafinal: yup.date().required(),
  valorinss: yup.number().required(),
}); 

export const DialogFeriasAlterar: React.FC<ConfirmationDialogRawProps> = (props: ConfirmationDialogRawProps) => {
  const { formRef, save } = useVForm();
  const { onClose, value: valueProp, open, ...other } = props;
  const [value, setValue] = useState(valueProp);
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState('');
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  
               
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event, 
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
    if(tms === 'success'){  
      onClose(); 
    }
  };

  useEffect(() => {
    if (props.dados && typeof props.dados === 'object') {
      formRef.current?.setData(props.dados); 
    }  
  }, [id]);
 
  const handleCancel = () => {
    onClose();
  };

  useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }else{
      setId(valueProp);
    }
  }, [valueProp, open]);
  
  const handleSave = (dados: IFormData) => {
    FeriasSchema.validate(dados, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);
        FeriasService.updateById(props.id, dadosValidados)
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              setTms('error');
              setMsg(result.message);
              setOpenmsg(true);
            } else {
              setTms('success');
              setMsg('Lançamento Realizado com sucesso!');
              setOpenmsg(true);
            }
          });
      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };

  return (
    <Dialog
      open={open}
      {...other}      
    >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <DialogTitle>Alterar Férias</DialogTitle>
      <DialogContent dividers>
        <VForm ref={formRef} onSubmit={handleSave}>
          <Box display="flex" padding={3} gap={1} component={Paper} variant="outlined">
            <Grid container marginTop={1} item direction="row" spacing={1.5} >
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item direction="row" spacing={1.5}>
                  <Grid item xs={6} sm={12} md={3} lg={4} xl={4}>
                    <VTextFieldData
                      fullWidth
                      size='small'
                      name='datainicial'
                      label='Data de Inicial'
                      disabled={isLoading}
                    />
                  </Grid>
                  <Grid item xs={6} sm={12} md={3} lg={4} xl={4}>
                    <VTextFieldData
                      fullWidth
                      size='small'
                      name='datafinal'
                      label='Data de Final'
                      disabled={isLoading}
                    />
                  </Grid>
                  <Grid item xs={6} sm={12} md={3} lg={4} xl={4}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='valorinss'
                      label='Valor'
                      disabled={isLoading}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </VForm> 
      </DialogContent>
      <DialogActions>
        <Button size='small' sx={{ minWidth:'30%'  }} variant='outlined' onClick={handleCancel}>Voltar</Button>      
        <Button size='small' sx={{ minWidth:'30%'  }} variant='contained' onClick={save}>Alterar</Button>     
      </DialogActions>
    </Dialog>
  );
}; 